import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

export default defineNuxtPlugin({
  name: "autoAnimate",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.use(autoAnimatePlugin);
  },
});
